import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { PatientTherapyId } from '@app/icare/entities/patient/schema/PatientTherapy'
import { PatientTherapyOverview } from '@app/icare/routes/_app/patienten/$id/_edit/_therapy/-components/PatientTherapyOverview'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_therapy/therapien/$relation')({
  params: entityParams({ id: PatientId, relation: PatientTherapyId }),
  component: RouteComponent,
})

function RouteComponent() {
  const { id, relation } = Route.useParams()

  return <PatientTherapyOverview patientId={id} relationId={relation} />
}
